import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {fetch} from '@yandex-delivery/core/utils/network'
import {addQuery} from '@yandex-delivery/utils'

export function fetchOrderAvailability(country?: string): Promise<{}> {
  return fetch({
    method: 'POST',
    url: addQuery(externalApiURL('cargo-corp/v1/client/order/availability'), {country}),
  })
}
